import { h } from 'preact';
import { withTheme } from 'styled-components';
import { useTranslation } from 'react-i18next';
import { useGlobalConfigContext } from 'GlobalConfig.context';
import type { WidgetConfigs } from 'interfaces/WidgetConfigs.interface';
import type PmParcel from 'interfaces/PmParcel';
import { useEdd } from './hooks';
import {
  Container,
  MainBox,
  Description,
  Title,
} from './EstimatedDeliveryDate.styles';

interface EstimatedDeliveryDateProps {
  parcel: PmParcel;
  theme: WidgetConfigs;
}

const EstimatedDeliveryDate = ({
  parcel,
  theme,
}: EstimatedDeliveryDateProps) => {
  const { t } = useTranslation();
  const { organizationId: orgId = 0 } = useGlobalConfigContext();
  const { shouldRemoveSectionGap } = theme.configs.parcelDetailsBox;

  const { isLoading, shouldDisplay, title, description } = useEdd({
    parcel,
    orgId,
  });

  if (isLoading) {
    return (
      <Container shouldRemoveSectionGap={shouldRemoveSectionGap}>
        <MainBox>
          <Description data-testid="edd-description">
            {t('ESTIMATED_DELIVERY')}
          </Description>
          <Title data-testid="edd-title">...</Title>
        </MainBox>
      </Container>
    );
  }

  if (!shouldDisplay) {
    return null;
  }

  return (
    <Container shouldRemoveSectionGap={shouldRemoveSectionGap}>
      <MainBox>
        <Description data-testid="edd-description">{description}</Description>
        <Title data-testid="edd-title">{title}</Title>
      </MainBox>
    </Container>
  );
};

export default withTheme(EstimatedDeliveryDate);
